import {ControlledInput} from '@hm/fundamental'
import React from 'react'
import {Controller, useFormContext} from 'react-hook-form'

import {useTranslation} from '../../../hooks/useTranslation'
import {CHANGE_COMMON_DATASCOPE_VALUE} from '../../../modules/GroupedRoleAssignmentReducer'
import {GroupedRoleAssignment} from '../../../modules/ManageUsers.selectors'
import {checkRequired} from '../utils'

type TextDataScopeProps = {
  isRequired: boolean
  errorMessage: string
  dataScopeName: string
  multiSelect: boolean
  dispatchRoleStateUpdate: any
}

export const TextDataScope = ({
  isRequired,
  errorMessage,
  dataScopeName,
  multiSelect,
  dispatchRoleStateUpdate
}: TextDataScopeProps) => {
  const {control, getValues} = useFormContext<GroupedRoleAssignment>()
  const {t} = useTranslation()
  const fieldName = `commonDataScopes.${dataScopeName}`

  return (
    <Controller
      key={dataScopeName}
      name={fieldName as keyof GroupedRoleAssignment}
      control={control}
      rules={{
        validate: checkRequired(
          isRequired,
          multiSelect,
          t('roleAssignment.dataScopeRequired', {
            dataScope: t(`roleAssignment.dataScope.${dataScopeName}`)
          })
        )
      }}
      render={({field}) => (
        <ControlledInput
          {...field}
          label={t(`roleAssignment.dataScope.${dataScopeName}`)}
          className="max-w-[600px]"
          error={errorMessage}
          required={isRequired}
          value={(getValues().commonDataScopes[dataScopeName] as string) || ''}
          onChange={(event) => {
            field.onChange(event)

            dispatchRoleStateUpdate({
              type: CHANGE_COMMON_DATASCOPE_VALUE,
              payload: {
                name: dataScopeName,
                value: event.target.value
              }
            })
          }}
        />
      )}
    />
  )
}
